import { useMemo } from 'react';
import useOrderDetailStore from 'global/Securities/stores/useOrderDetailStore';

interface ReturnType {
  showRealized: boolean;
  isLoss: boolean;
  totalRealized: number;
  realizedPercentage: number;
}

export default function useCalculateRealized(
  symbol: string,
  amountMatchedTotal: number,
  qtyLotDone: number,
): ReturnType {
  const orderDetail = useOrderDetailStore((s) => s.data);
  const portfolioAvgPrice = orderDetail?.price_average_portfolio;

  const showRealized = useMemo(
    () =>
      portfolioAvgPrice &&
      qtyLotDone !== 0 &&
      amountMatchedTotal / qtyLotDone !== 0,
    [portfolioAvgPrice, qtyLotDone, amountMatchedTotal],
  );

  // Realized Gain / Loss
  const totalRealized = useMemo(
    () => amountMatchedTotal - portfolioAvgPrice * (qtyLotDone * 100),
    [portfolioAvgPrice, qtyLotDone, amountMatchedTotal],
  );

  const realizedPercentage = useMemo(
    () =>
      Math.abs(
        (amountMatchedTotal - portfolioAvgPrice * (qtyLotDone * 100)) /
          (portfolioAvgPrice * (qtyLotDone * 100)),
      ),
    [portfolioAvgPrice, qtyLotDone, amountMatchedTotal],
  );

  const isLoss = useMemo(() => totalRealized < 0, [totalRealized]);

  return {
    showRealized,
    isLoss,
    totalRealized,
    realizedPercentage,
  };
}
